import config from "../config";

export const getDashboardData = async (shopId, from, to, employeeId) => {
  if (shopId === "") return;
  return await Promise.all([
    fetch(`${config.newApiGateway}/bill/getBillDetails`, {
      method: "POST",
      body: JSON.stringify({
        action: "getDashboardData",
        userId: shopId,
        type: "bill",
        from,
        to,
        employeeId: employeeId ? employeeId : "",
      }),
      headers: {
        "x-api-key": `${config.newApiKey}`,
        "Content-Type": "application/json",
      },
    }),
  ])
    .then(([res]) => Promise.all([res.json()]))
    .then(async ([data]) => {
      return data;
    })
    .catch((err) => {
      console.log("err".err);
    });
};

export const getShopDetails = async (shopId) => {
  var shopDetailsRes = await fetch(
    `${config.newApiGateway}/customer/createCustomerandgetCustomer`,
    {
      method: "POST",
      body: JSON.stringify({
        shopId: shopId,
        action: "getShopDetails",
      }),
      headers: {
        "x-api-key": `${config.newApiKey}`,
        "Content-Type": "application/json",
      },
    }
  );
  shopDetailsRes = await shopDetailsRes.json();
  return shopDetailsRes.Items?.[0];
};

export const getSmsPackageDetails = async (shopId) => {
  return await Promise.all([
    fetch(`${config.newApiGateway}/alias/updateAlias`, {
      method: "POST",
      body: JSON.stringify({
        action: "sms",
        shopId,
      }),
      headers: {
        "x-api-key": `${config.newApiKey}`,
        "Content-Type": "application/json",
      },
    }),
  ])
    .then(([res]) => Promise.all([res.json()]))
    .then(async ([data]) => {
      return data;
    })
    .catch((err) => {
      console.log("err".err);
    });
};

export const getBillDetails = async (shopId, employeeId) => {
  if (shopId === "") return;
  return await Promise.all([
    fetch(`${config.newApiGateway}/bill/getBillDetails`, {
      method: "POST",
      body: JSON.stringify({
        userId: shopId,
        type: "bill",
        employeeId: employeeId ? employeeId : "",
      }),
      headers: {
        "x-api-key": `${config.newApiKey}`,
        "Content-Type": "application/json",
      },
    }),
  ])
    .then(([res]) => Promise.all([res.json()]))
    .then(async ([data]) => {
      return data;
    })
    .catch((err) => {
      console.log("err".err);
    });
};

export const getProductDetails = async (shopId, empId) => {
  console.log("getProductDetails2", shopId, empId);
  return await Promise.all([
    fetch(`${config.newApiGateway}/products/dashboard-products-allproducts`, {
      method: "POST",
      body: JSON.stringify({
        userId: shopId,
        employeeId: empId ? empId : "",
        type: "getProductDetails",
      }),
      headers: {
        "x-api-key": `${config.newApiKey}`,
        "Content-Type": "application/json",
      },
    }),
  ])
    .then(([res]) => Promise.all([res.json()]))
    .then(async ([data]) => {
      console.log("getProductDetails", data);
      if (data.limitExceeds && data.status) {
        try {
          var productData = await fetch(data.products);
          productData = await productData.json();
          return productData;
        } catch (err) {
          alert("Failed to fetch product details. Please try again");
          return;
        }
      }
      return data;
    })
    .catch((err) => {
      console.log("Err", err);
    });
};

// export const addProduct = async (productDetails) => {
//   return await Promise.all([
//     fetch(`${config.ApiGateway1}/addProduct`, {
//       method: "POST",
//       body: JSON.stringify(productDetails),
//       headers: {
//         "Content-Type": "application/json",
//       },
//     }),
//   ])
//     .then(([res]) => Promise.all([res.json()]))
//     .then(async ([data]) => {
//       return data;
//     })
//     .catch((err) => {
//       return err;
//     });
// };

// export const updateProduct = async (productDetails) => {
//   return await Promise.all([
//     fetch(`${config.ApiGateway1}/addProduct`, {
//       method: "POST",
//       body: JSON.stringify(productDetails),
//       headers: {
//         "Content-Type": "application/json",
//       },
//     }),
//   ])
//     .then(([res]) => Promise.all([res.json()]))
//     .then(async ([data]) => {
//       return data;
//     })
//     .catch((err) => {
//       return err;
//     });
// };

// export const removeProduct = async (data) => {
//   return await Promise.all([
//     fetch(`${1}/deleteProduct`, {
//       method: "POST",
//       body: JSON.stringify({
//         productId: data.productId,
//         versionId: data.versionId,
//       }),
//       headers: {
//         "Content-Type": "application/json",
//       },
//     }),
//   ])
//     .then(([res]) => Promise.all([res.json()]))
//     .then(async ([data]) => {
//       return data;
//     })
//     .catch((err) => {
//       return err;
//     });
// };

// export const productLive = async (data) => {
//   return await new Promise(async (resolve, reject) => {
//     return await fetch(`${config.ApiGateway1}/makeProductLive`, {
//       method: "POST",
//       body: JSON.stringify({
//         productId: data.productId,
//         versionId: data.versionId,
//       }),
//       headers: {
//         "Content-Type": "application/json",
//       },
//     })
//       .then(([res]) => Promise.all([res.json()]))
//       .then(async ([data]) => {
//         resolve(data);
//       })
//       .catch((err) => {
//         reject(err);
//       });
//   });
// };
